<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [height]="300" [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-utysa-tabedit [srv]="srv"></app-utysa-tabedit> -->
    <div style="max-height: 300px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
        <app-jktext label="主資料表" [value]="item.SA001">
        </app-jktext>
        <app-jktext label="序號" [value]="item.SA002">
        </app-jktext>
        <app-jktext label="使用者代號" [value]="item.SA003">
        </app-jktext>
        <app-jktext label="保留" [value]="item.SA004">
        </app-jktext>
        <app-jktextarea height="250px" label="備註" #SA005Com id="SA005" [(value)]="item.SA005" [readonly]="true">
        </app-jktextarea>

      </div>
    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>